import styled, { css } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const GameTypeContainer = styled.div<{ $isStartOfGameType: boolean }>`
    color: ${({ theme }) => theme.Utility.critical};
    height: 20px;
    margin-bottom: 24px;
    text-align: center;

    ${BaseStyle.Mixins.screenSizes.medium} {
        margin-bottom: 0;
    }

    ${({ $isStartOfGameType }) =>
        $isStartOfGameType &&
        css`
            margin-top: 32px;
        `};
`;

export const Separator = styled.div`
    background: ${({ theme }) => theme.Utility.critical};
    height: 1px;
    position: relative;
    top: 10px;
`;

export const DescriptionContainer = styled.div`
    display: flex;
    justify-content: center;
`;

export const Description = styled.div`
    background: ${({ theme }) => theme.Utility.contrast};
    color: ${({ theme }) => theme.Utility.critical};
    ${BaseStyle.Mixins.fontStyles.desktop.subtitle3};
    padding: 0 16px;
    z-index: 1;
`;
